import { useEffect, useState } from 'react';
import { fetchActiveTrials } from 'pricing-pages-lib/api/fetchActiveTrials';
import { EBX638_GROUP_PARAMETER_KEY, EBX638_GROUP_PARAMETER_OPTIONS, EBX638_TREATMENT_KEY, PARAMETERS } from '../constants/experimentKeys';
import { laboratoryClient } from '../utils/laboratoryClient'; //EBX638: Limit usage in the interstitial

export const useIsEBX638Variant = () => {
  const [isEbx638Variant, setIsEbx638Variant] = useState();
  useEffect(() => {
    laboratoryClient.resolve(treatments => {
      if (Object.keys(treatments).length) {
        const optionValue = treatments[EBX638_TREATMENT_KEY][PARAMETERS][EBX638_GROUP_PARAMETER_KEY];
        setIsEbx638Variant(optionValue === EBX638_GROUP_PARAMETER_OPTIONS.variant);
      }
    });
  }, [isEbx638Variant]);
  return isEbx638Variant;
}; //EBX638

export const useIsInActiveTrial = () => {
  const [isInActiveTrial, setIsInActiveTrial] = useState(true);
  useEffect(() => {
    fetchActiveTrials().then(activeTrials => {
      if (activeTrials.length > 0) {
        setIsInActiveTrial(true);
      } else setIsInActiveTrial(false);
    }).catch(() => {
      setIsInActiveTrial(false);
    });
  }, []);
  return isInActiveTrial;
};